import { useNavigate } from "react-router-dom";
import { useGlobal, useScreen } from "../../../core/Global";
import FlexRow from "../../base/FlexRow";
import Icon from "../../base/Icon";



interface IProps {
    title?: string
}
export default function PageTitleBar(props: IProps) {

    const [globalState] = useGlobal()
    const navigate = useNavigate()
    const screen = useScreen()

    // On mobile these pages open inside a drawer whose own header shows the title
    // and actions, so the page-level title bar is redundant.
    if (screen.isMobile) return (<></>);

    if (!globalState.page?.title) return (<></>);

    return (
        <FlexRow id="kt-page-title-bar" className="py-3 pt-5 px-10 bg-body border-bottom">

            <div className="text-dark fw-bolder fs-4 fs-xxxl-3">
                {globalState.page?.title}
            </div>

            <div className="d-flex align-items-center justify-contents-end ms-auto">

                {
                    globalState.toolbarActions && <globalState.toolbarActions />
                }

                {
                    globalState.toolbarButton &&
                    <button className={`btn btn-sm btn-${globalState.toolbarButton.color}`}
                        disabled={globalState.toolbarButton.working} onClick={globalState.toolbarButton.onClick}>
                        {
                            globalState.toolbarButton.working ?
                                <>
                                    <Icon icon="spinner-third" spin />
                                    <span className="ms-2">{globalState.toolbarButton.title}</span>
                                </>
                                :
                                <>
                                    {globalState.toolbarButton.icon && <Icon icon={globalState.toolbarButton.icon} />}
                                    <span>{globalState.toolbarButton.title}</span>
                                </>
                        }
                    </button>
                }

            </div>

        </FlexRow>
    )
}